import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop errors (common with Radix UI components)
// These errors don't affect functionality
if (typeof window !== 'undefined') {
  const suppressedMessages = [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications'
  ];

  // Suppress in error events
  window.addEventListener('error', (e) => {
    if (e.message && suppressedMessages.some(msg => e.message.includes(msg))) {
      e.stopImmediatePropagation();
      e.preventDefault();
      
      // Hide webpack overlay if present
      setTimeout(() => {
        const overlay = document.getElementById('webpack-dev-server-client-overlay');
        if (overlay) overlay.style.display = 'none';
        const overlayDiv = document.getElementById('webpack-dev-server-client-overlay-div');
        if (overlayDiv) overlayDiv.style.display = 'none';
      }, 0);
      
      return true;
    }
  }, true);

  // Suppress in unhandled rejection
  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason && e.reason.message && suppressedMessages.some(msg => e.reason.message.includes(msg))) {
      e.preventDefault();
      return true;
    }
  });

  // Override console.error
  const originalConsoleError = console.error;
  console.error = (...args) => {
    const message = args[0]?.toString() || '';
    if (suppressedMessages.some(msg => message.includes(msg))) {
      return;
    }
    originalConsoleError.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
